// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-10-23T13:08:09Z                      #

// ##############################################################


/**
 * 
 */
enum ModuleCode {
        MARBES = 'MARBES', 
        HSM = 'HSM', 
        ICA = 'ICA', 
        SECUSIGN = 'SECUSIGN'
};
export default ModuleCode;
